var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("Buyer Accounts")]),_c('CCard',[(_vm.buyerAccounts && _vm.buyerAccounts.length > 0)?_c('AccountsList',{attrs:{"is-loading":_vm.isLoading,"accounts":_vm.buyerAccounts,"type":"buyer"}}):_vm._e()],1),_c('h4',{staticClass:"mt-5"},[_vm._v(" Inactive Buyer Accounts ")]),_c('InactiveAccountsList',{attrs:{"type":"buyer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }